import { Text, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";

import { useClosableModal } from "./closable-modal/closable-modal-context";
import ModalCloseButton from "./modal-close-button";
import SafeHorizontal from "./safe-horizontal";

function ModalTitle({ title, right }: { title: string; right?: any }) {
  const context = useClosableModal();
  const onClose = context?.onRequestClose;
  return (
    <SafeHorizontal
      sx={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        px: Platform.select({ web: ["$2", "$4"] as any, default: "$2" }),
        py: "$4",
        paddingBottom: Platform.select({ default: "$2", web: ["$2", "$4"] as any }),
      }}
    >
      <View sx={{ flexDirection: "row", alignItems: "center" }}>
        {right ? (
          <View sx={{ marginRight: "$2", marginLeft: -5 }}>
            <ModalCloseButton onPress={onClose} />
          </View>
        ) : null}
        <Text sx={{ fontSize: 18, fontWeight: "600" }}>{title}</Text>
      </View>
      {right ? (
        <View>{right}</View>
      ) : (
        <View sx={{ marginRight: -5 }}>
          <ModalCloseButton onPress={onClose} />
        </View>
      )}
    </SafeHorizontal>
  );
}
export default ModalTitle;
